var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "claim-closing view" }, [
    _c("div", { staticClass: "view_content" }, [
      _vm.getFlowName === "billma_bpce"
        ? _c("div", { staticClass: "view_content_markdown" }, [
            _c("h1", { staticClass: "centered-text" }, [
              _vm._v(_vm._s(_vm.$t("closing.bpce.title"))),
            ]),
            _c("p", [_vm._v(_vm._s(_vm.$t("closing.bpce.upper1")))]),
          ])
        : _c("div", [
            _c(
              "div",
              { staticClass: "view_content_markdown" },
              [
                _c("img", {
                  staticClass: "mg mg--b-3 icon centered-img",
                  attrs: {
                    src: require("@/assets/images/self-care/checkmark-circle.png"),
                  },
                }),
                _vm._l(_vm.getFlowViewContent, function (content) {
                  return [
                    content.type === "TITLE"
                      ? _c("h1", { staticClass: "centered-text" }, [
                          _vm._v(_vm._s(content.literal)),
                        ])
                      : _vm._e(),
                    content.type === "PARAGRAPH"
                      ? _c("p", {
                          domProps: { innerHTML: _vm._s(content.literal) },
                        })
                      : _vm._e(),
                    content.type === "HR"
                      ? _c("hr", { staticClass: "mg mg--b-3" })
                      : _vm._e(),
                    content.type === "PHONE"
                      ? _c(
                          "a",
                          {
                            staticClass: "phone-container mg mg--b-3",
                            attrs: { href: _vm.formatPhone(content.literal) },
                          },
                          [
                            _c("svgicon", {
                              staticClass: "icon",
                              attrs: {
                                name: "phone",
                                color: "#005BA5",
                                height: "15",
                                width: "auto",
                              },
                            }),
                            _c("p", { staticClass: "phone-number" }, [
                              _vm._v(_vm._s(content.literal)),
                              _c("span", [_vm._v("(prix d'un appel local)")]),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    content.type === "BULLET_ICON"
                      ? _c("div", { staticClass: "closing-bullet-icon" }, [
                          _c("img", {
                            staticClass: "closing-bullet-icon-img",
                            attrs: { src: content.image },
                          }),
                          _c("p", { staticClass: "closing-bullet-icon-text" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatBulletLiteral(content.literal))
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }